module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia9-86f3c63119dbc74424535ebeca64cff8.jpg";